<template>
  <div class="preview-popup" :class="{ active: popUpActive }">
    <div class="file-name">
      <img :src="$_getFilePhoto(textLabel)" alt="" />
      <p class="file-name__text">
        {{ $_getFileName(textLabel) }}{{ $_getFileExtension(textLabel) }}
      </p>
    </div>
    <a v-if="download" class="download-btn" download @click.stop="$_downloadClick(textLabel)">
      <i class="icon-cloud-download" />
    </a>
    <div class="popup-container-wrap">
      <div class="popup-container">
        <iframe
          v-if="$_pdfFile(textLabel)"
          :id="'myframe' + num"
          :ref="'myframe' + num"
          :src="textLabel"
          width="600px"
          height="660px"
        />
        <img v-else-if="$_imgFile(textLabel)" :src="textLabel" alt="" />
        <div v-else class="no-preview">
          <p>{{ $t('此檔案無法預覽') }}</p>
          <a download>
            <WsButton001 leading-icon="icon-cloud-download" @click="$_downloadClick(textLabel)">
              {{ $t('下載檔案') }}
            </WsButton001>
          </a>
        </div>
      </div>
    </div>
    <div class="preview-popup_bg" @click.stop="$_popUpClose()" />
  </div>
</template>
<script>
import filePhotos from '@/spare/file-photos';

export default {
  name: 'WsPreviewPopUp001',
  props: {
    popUpActive: {
      type: Boolean,
      default: false,
    },
    textLabel: {
      type: String,
      default: '',
    },
    download: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    currentPage: 0,
    pageCount: 0,
    imgFormat: 'gif|png|jpg|jpeg',
    pdfFormat: 'pdf',
    filePhotos: filePhotos.filePhotos,
  }),
  methods: {
    $_getFilePhoto(textLabel) {
      if (!textLabel) return;
      let fileExtension = this.$_getFileExtension(textLabel).substring(1);
      if (!fileExtension) return require('@/assets/image/thumbnail_file/other-other.png');
      let file;
      this.filePhotos.forEach(filePhoto => {
        if (filePhoto.file.includes(fileExtension)) {
          file = filePhoto.image;
        }
      });
      return file ? file : require('@/assets/image/thumbnail_file/other-other.png');
    },
    $_popUpClose() {
      this.$emit('click');
    },
    $_getFileName(url) {
      if (!url) return;
      if (url) {
        var filename = url.toString().match(/.*\/(.+?)\./);
        if (filename && filename.length > 1) {
          return decodeURI(filename[1]);
        }
      }
      return '';
    },
    $_getFileExtension(url) {
      if (!url) return;
      return (url = url.substring(1 + url.lastIndexOf('/')).split('?')[0])
        .split('#')[0]
        .substring(url.lastIndexOf('.'));
    },
    $_imgFile(text) {
      if (!text) {
        return;
      }
      var found = text.match(this.imgFormat);
      if (!found) {
        return;
      }
      if (found.length > 0) {
        return true;
      }
    },
    $_pdfFile(text) {
      if (!text) {
        return;
      }
      var found = text.toLowerCase().match(this.pdfFormat);
      if (!found) {
        return;
      }
      if (found.length > 0) {
        return true;
      }
      return text;
    },
    $_downloadClick(text) {
      const fileName = this.$_getFileName(text) + this.$_getFileExtension(text);
      fetch(text).then(function (t) {
        return t.blob().then(b => {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(b);
          a.setAttribute('download', fileName);
          a.click();
        });
      });
    },
  },
};
</script>
